import randomId from 'javascripts/utils/random-id';
import Slider from '../../../javascripts/globals/slider';
import { Pagination, Thumbnails, setOnSlideChange } from '../../../javascripts/globals/slider-extensions';

export default class MediaGallery {
  constructor($el, options) {
    this.$el = $el;
    this.id = options.id || `media-gallery${randomId()}`;

    const localOptions = {
      id: this.id,
      ...options,
    };

    this.initSlider(localOptions);
    this.initPagination(localOptions);
    this.initThumbnails(localOptions);

    this.bindEvents();
  }

  initSlider(options) {
    this.slider = new Slider(this.$el, options);
  }

  initPagination(options) {
    this.pagination = new Pagination(this.$el, this.slider, options);
  }

  initThumbnails(options) {
    this.thumbnails = new Thumbnails(this.$el, this.slider, options);
  }

  bindEvents() {
    setOnSlideChange(this.slider, this.onSlideChange.bind(this));
  }

  onSlideChange(currentIndex) {
    const { $sliderItems } = this.slider;
    $sliderItems.forEach(($slide, index) => {
      if (index === currentIndex) return;

      const $video = $slide.querySelector('video');
      if ($video === null) return;

      if ($video.paused) return;

      $video.pause();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-media-gallery').forEach(
    $imageTextSlider => new MediaGallery($imageTextSlider, {
      sliderFrame: 'media-gallery__items',
      sliderItem: 'media-gallery__item',
      pagination: 'media-gallery__pagination',
      thumbnails: 'media-gallery__thumbnails',
      activeThumbnail: 'media-gallery__thumbnail--active',
    }),
  );
});
